import { render } from "./ItemDialog.vue?vue&type=template&id=58378b4e&scoped=true"
import script from "./ItemDialog.vue?vue&type=script&lang=js"
export * from "./ItemDialog.vue?vue&type=script&lang=js"

import "./ItemDialog.vue?vue&type=style&index=0&id=58378b4e&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-58378b4e"

export default script